import React from 'react'
import "./skill.css"
export default function Skill() {
  return (
    <div  className='skillheading'>
        <h1>Technical Skills</h1>

      <div className='skillstyle'>
        
      <div className='skillcss'>
         <img src='https://chiranjeev-thapliyal.vercel.app/svg/html-5.svg' />
          <h4>HTML</h4>
         </div>

         <div className='skillcss'>
         <img src='https://chiranjeev-thapliyal.vercel.app/svg/css3.svg'/>
          <h4>CSS</h4>
         </div>


         <div className='skillcss'>
         <img src='https://chiranjeev-thapliyal.vercel.app/svg/javascript.svg' />
          <h4>JAVASCRIPT</h4>
         </div>
         

         <div className='skillcss'>
         <img src='https://rahul-rajeevan-portfolio.netlify.app/static/media/react1.4e0c97009b885bfa75c5412262a46f5f.svg' />
          <h4>REACT</h4>
         </div>

         <div className='skillcss'>
         <img src='https://rahul-rajeevan-portfolio.netlify.app/static/media/mongodb.6835c61a518a732eb8318d43dfe8f700.svg' />
          <h4>MONGODB</h4>
         </div>
         

         <div className='skillcss'>
         <img src='https://chiranjeev-thapliyal.vercel.app/svg/redux.svg' />
          <h4>REDUX</h4>
         </div>
         

         <div className='skillcss'>
         <img src='https://rahul-rajeevan-portfolio.netlify.app/static/media/node.10c9e2aa0ca7edf36fceae25fec038a1.svg'/>
          <h4>NODE JS</h4>
         </div>


         <div className='skillcss'>
         <img src='https://chiranjeev-thapliyal.vercel.app/svg/git.svg' />
          <h4>GIT</h4>
         </div>
         

         
         <div className='skillcss'>
         <img src='https://rahul-rajeevan-portfolio.netlify.app/static/media/chakraui.15320604467d004df871.png' />
          <h4>CHAKRA UI</h4>
         </div>
         
         
         <div className='skillcss'>
         <img src='https://i.pinimg.com/originals/a7/cb/99/a7cb99c5b28b4c6bf7c1ee8e56436567.jpg' alt='express' />
          <h4>EXPRESS</h4>
         </div>
         
         

      
      </div>
      
    </div>
  )
}
